<template>
  <v-card outlined rounded="lg">
    <v-alert v-if="error" type="error" class="mb-0">{{ error }}</v-alert>
    <v-card-text v-else class="d-flex flex-wrap justify-space-around px-">
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights?.pendingCount | number }}
        </h6>
        <span class="text-caption"> Solicitações pendentes </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ approvedCount.allowAi | number }}
        </h6>
        <span class="text-caption"> Solicitações aprovadas com IA </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ approvedCount.notAllowAi | number }}
        </h6>
        <span class="text-caption"> Solicitações aprovadas manualmente </span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ approvedCount.total | number }}
        </h6>
        <span class="text-caption"> Beneficiários ativos </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CONCESSION_REQUEST from "@/services/admin/concessionRequest";
import EvolutionDisplay from "../../global/EvolutionDisplay.vue";

export default {
  components: { EvolutionDisplay },
  data() {
    return {
      highlights: null,
      loading: false,
      error: null,
    };
  },
  methods: {
    async getHighlights() {
      this.loading = true;
      try {
        const response = await CONCESSION_REQUEST.getResume();
        this.highlights = response;
      } catch (error) {
        this.error = error.message || "Erro ao buscar dados";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    approvedCount() {
      const data = {
        total: 0,
        allowAi: 0,
        notAllowAi: 0,
      };
      this.highlights?.approvedCount.forEach((item) => {
        data.total += item._count;
        if (item.allowAi) data.allowAi += item._count;
        else data.notAllowAi += item._count;
      });
      return data;
    },
  },
  mounted() {
    this.$parent.$on("refresh", this.getHighlights);
  },
  beforeUnmount() {
    this.$parent.$off("refresh", this.getHighlights);
  },
  created() {
    this.getHighlights();
  },
};
</script>

<style></style>
